import React, { Component } from 'react';
import Draggable from 'react-draggable';

import TextInput from './text_input';
import CheckBoxInput from './checkbox_input';
import DateInput from './date_input';
import SignatureInput from './signature_input';

class EditorForm extends Component {
    render() {
        const { editable, formData, onDelete, onChange, position } = this.props;
        let editorForm;

        switch (formData.type) {
            case 'text':
                editorForm = (
                    <DraggableInput
                        onStop={(event) => this.props.handleMove(event)}
                        position={position}
                        defaultPosition={position}
                        bounds={'parent'}
                        editable={editable}
                    >
                        <TextInput
                            formData={formData}
                            editable={editable}
                            onDelete={onDelete}
                            onChange={onChange}
                            position={position} />
                    </DraggableInput>
                );
                break;
            case 'checkbox':
                editorForm = (
                    <Draggable
                        onStop={(event) => this.props.handleMove(event)}
                        position={position}
                        bounds={'parent'}
                        editable={editable}>
                        <CheckBoxInput
                            formData={formData}
                            editable={editable}
                            onDelete={onDelete}
                            onChange={onChange}
                            position={position} />
                    </Draggable>
                );
                break;
            case 'date':
                editorForm = (
                    <Draggable
                        onStop={(event) => this.props.handleMove(event)}
                        position={position}
                        bounds={'parent'}
                        editable={editable}
                    >
                        <DateInput
                            formData={formData}
                            editable={editable}
                            onDelete={onDelete}
                            onChange={onChange}
                            position={position} />
                    </Draggable>
                );
                break;
            case 'signature':
                editorForm = (
                    <Draggable
                        onStop={(event) => this.props.handleMove(event)}
                        position={position}
                        bounds={'parent'}
                        editable={editable}
                    >
                        <SignatureInput
                            formData={formData}
                            editable={editable}
                            onDelete={onDelete}
                            onChange={onChange}
                            position={position} />
                    </Draggable>
                );
                break
            default:
                editorForm = <div>EditorForm</div>;
                break;
        }

        return editorForm;
    }

};

const DraggableInput = (props) => {
    if (props.editable) {
        return (
            <Draggable onStop={props.onStop} position={props.position} bounds={'parent'}>
                {props.children}
            </Draggable>
        )
    } else {
        return props.children;
    }
}

export default EditorForm;



// WEBPACK FOOTER //
// ./src/components/document-editor/editor_form.jsx